import type { IconProps } from './types';

export const Ethereum = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none" aria-hidden="true" {...props}>
    <g clipPath="url(#clip0_17328_19213)">
      <path
        d="m12.9382 19.6542-7.98117-4.7101 7.97627 11.2442 7.9853-11.2442-7.9853 4.7101h.0049ZM13.0568.1875 5.07891 13.4288l7.97789 4.7182 7.9812-4.7133L13.0568.1875Z"
        fill="var(--color-quanta-icon)"
      />
    </g>
    <defs>
      <clipPath id="clip0_17328_19213">
        <rect width="26" height="26" fill="var(--color-quanta-icon)" transform="translate(0 0.1875)" />
      </clipPath>
    </defs>
  </svg>
);
